export default "__VITE_ASSET__e3395ef6__"